export const ToolsOptions = [
  { key: 'configuration', label: 'Konfiguration', icon: '/assets/img/ic-config-dock.svg' },
  { key: 'tasks', label: 'Aufgaben', icon: '/assets/img/ic-task-dock.svg' },
  { key: 'changes', label: 'Änderungen', icon: '/assets/img/ic-changes-dock.svg' },
  { key: 'orders', label: 'Bestellungen', icon: '/assets/img/ic-orders-dock.svg' },
  { key: 'corrections', label: 'Nachbesserung', icon: '/assets/img/ic-files-dock.svg' },
  { key: 'team', label: 'Team', icon: '/assets/img/ic-team-dock.svg' },
  { key: 'contacts', label: 'Kontakte', icon: '/assets/img/ic-contacts-dock.svg' },
  { key: 'calendar', label: 'Kalender', icon: '/assets/img/ic-calendar-dock.svg' },
  { key: 'logbook', label: 'Logbuch', icon: '/assets/img/ic-logbook.svg' },
  { key: 'siteDiary', label: 'Tagebuch', icon: '/assets/img/ic-project-diary.svg' }
];

// TODO: Remove this temporary user restriction when Tagebuch is released for all users.
export const SITE_DIARY_ENABLED_USER_IDS = [32, 350, 345, 364];

export function getToolsOptionsForUser(userId?: number): typeof ToolsOptions {
  return ToolsOptions.filter(
    (option) =>
      option.key !== 'siteDiary' || (userId !== undefined && SITE_DIARY_ENABLED_USER_IDS.includes(userId))
  );
}
